import { Injectable } from '@angular/core';
import { SimpleQueryUser } from './simpleQueryUser';

@Injectable()
export class ReferentielDTO {

  public objet: SimpleQueryUser;
  public idSociete?: number;
}
